import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType, computed} from "vue";
import {LabelValue, VASelectOptions} from "typings";
import {useSelectHandler} from "./hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'VASelect',
  props: {
  value: {
    type: [String, Number, Boolean, Array],
    required: true
  },
  /*  接收静态和动态数据
  * 例：静态数据，和antd一样
  * [
  *   {label: '是', value: 1},
  *   {label: '否', value: 0}
  * ]
  * 动态数据，调用远程接口获取数据信息，获取网络区域信息
  * {
  *   uri: '/api/region',   调用的接口
  *   label: 'name',        需要展示的信息
  *   value: 'id'           最后绑定的值
  * }
  * */
  options: {
    type: [Array, Object] as PropType<VASelectOptions | Array<LabelValue>>,
    required: true
  },
  size: {
    type: String,
  },
  mode: {
    type: String,
  },
  placeholder: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: '100%'
  },
},
  emits: ["update:value", "on-change"],
  setup(__props, { expose: __expose, emit: __emit }) {


const emit = __emit
const props = __props

const {data, run: load} = useSelectHandler(props.options as VASelectOptions)

// 如果是多选模式，并且值是字符串，则需要转化为list
const formatValue = (value: any)=>{
  if(props.options.mode === "multiple"&&!(value instanceof Array)){
    if (!value || value === ''){
      return []
    }
    try{
      return JSON.parse(value)
    }catch{
      return value.split(",").map(item=>Number(item) || item)
    }

  }
  return value
}

// 如果直接是数据，则取数据值，否则取options里面的远程数据或者data
const source = computed(()=>{
  return props.options instanceof Array?props.options:data.value
})

const change = (value: any) =>{
  if(props.options.mode === "multiple"&&props.options.multipleValueType === 'string'){
    emit("update:value", JSON.stringify(value))
  }else{
    emit("update:value", value)
  }
  emit("on-change", value)
}

const filterOption = (input: string, option: LabelValue) => {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

__expose({load})


return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    disabled: __props.disabled,
    "allow-clear": "",
    "show-search": "",
    "filter-option": filterOption,
    value: formatValue(__props.value),
    size: __props.size,
    style: _normalizeStyle(`width: ${__props.width}`),
    placeholder: __props.placeholder || '请选择',
    mode: __props.mode || __props.options.mode,
    options: source.value,
    onChange: change
  }, null, 8, ["disabled", "value", "size", "style", "placeholder", "mode", "options"]))
}
}

})